import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';
import logo from '../../assets/onlyoven.png';
import Name from '../../assets/Name.png';
import { useTranslation } from 'react-i18next';
import italy from '../../assets/italy.jpg';
import spain from '../../assets/spanish.jpg';
import english from '../../assets/english.jpg';

// Importa i due PDF separatamente (assegna i percorsi corretti ai tuoi file)
import cartaMalaga from '../../components/homepage/carta_malaga.pdf';
import cartaSotogrande from '../../components/homepage/carta_sotogrande.pdf';

const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  // Nuovo stato per gestire la tendina della Carta
  const [isCartaOpen, setIsCartaOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const handleNavToggle = () => {
    setIsNavOpen(!isNavOpen);
    if (isNavOpen) setIsCartaOpen(false); // Chiude la tendina se si chiude la navbar mobile
  };

  const closeMenu = () => {
    setIsNavOpen(false);
    setIsCartaOpen(false);
  };

  const toggleCartaDropdown = (e) => {
    e.preventDefault(); // Impedisce il comportamento di default del link
    setIsCartaOpen(!isCartaOpen);
  };

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/" className="navbar-link" onClick={closeMenu}>
            <img src={logo} alt="forno" style={{ height: '35px', width: '35px', position: 'relative', left: '-3px' }} />
          </Link>
          <img src={Name} alt="forno" style={{ height: '35px', width: '150px', position: 'relative', left: '5px' }} />
        </div>

        <div className={`navbar-toggle ${isNavOpen ? 'active' : ''}`} onClick={handleNavToggle}>
          <span className="navbar-toggle-icon"></span>
        </div>
      </div>

      <ul className={`navbar-menu ${isNavOpen ? 'active' : ''}`}>
        {/* Language Selector */}
        <div className="language-selector">
          <button className={`language-button ${i18n.language === 'it' ? 'active' : ''}`} onClick={() => { changeLanguage('it'); closeMenu(); }}>
            <img src={italy} alt="Italiano" />
          </button>
          <button className={`language-button ${i18n.language === 'es' ? 'active' : ''}`} onClick={() => { changeLanguage('es'); closeMenu(); }}>
            <img src={spain} alt="Español" />
          </button>
          <button className={`language-button ${i18n.language === 'en' ? 'active' : ''}`} onClick={() => { changeLanguage('en'); closeMenu(); }}>
            <img src={english} alt="English" />
          </button>
        </div>

        {/* Navbar Items */}
        <li className="navbar-item">
          <Link to="/" className="navbar-link" onClick={closeMenu}>
            {t('navbar.home')}
          </Link>
        </li>

        {/* Voce CARTA modificata con Dropdown */}
        <li className={`navbar-item navbar-dropdown ${isCartaOpen ? 'open' : ''}`}>
          <a href="#carta" className="navbar-link dropdown-toggle" onClick={toggleCartaDropdown}>
            {t('navbar.menu')} <span className="dropdown-arrow">{isCartaOpen ? '▴' : '▾'}</span>
          </a>
          
          {isCartaOpen && (
            <ul className="dropdown-menu-list">
              <li>
                <a href={cartaMalaga} target="_blank" rel="noreferrer" onClick={closeMenu}>
                  Malaga
                </a>
              </li>
              <li>
                <a href={cartaSotogrande} target="_blank" rel="noreferrer" onClick={closeMenu}>
                  Sotogrande
                </a>
              </li>
            </ul>
          )}
        </li>

        <li className="navbar-item">
          <Link to="/aboutus" className="navbar-link" onClick={closeMenu}>
            {t('navbar.about')}
          </Link>
        </li>
        <li className="navbar-item">
          <Link to="/contactos" className="navbar-link" onClick={closeMenu}>
            {t('navbar.contact')}
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
